export default function returnCart() {
    window.location.hash = "/cart";
}
